import { Autocomplete, TextField } from "@mui/material";
import { renderCodeOption } from "../../../utils/functions";

const ApplicantFilters = ({
  yearOptions,
  applicationYear,
  setApplicationYear,
  statusOptions,
  status,
  setStatus,
  firstName,
  setFirstName,
  middleName,
  setMiddleName,
  lastName,
  setLastName,
  ssn,
  setSSN,
}) => {
  const textFilters = [
    ["First Name", firstName, setFirstName],
    ["Middle Name", middleName, setMiddleName],
    ["Last Name", lastName, setLastName],
    ["SSN", ssn, setSSN],
  ];

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        marginBottom: 10,
        marginTop: 10,
        gap: 10,
        flexWrap: "wrap",
      }}
    >
      <Autocomplete
        options={yearOptions}
        value={applicationYear}
        onChange={(_, newValue) => setApplicationYear(newValue)}
        getOptionLabel={(option) => option?.label || ""}
        isOptionEqualToValue={(o, v) => o?.value === v?.value}
        renderInput={(params) => (
          <TextField {...params} label="Application Period" size="small" />
        )}
        style={{ width: 200 }}
      />

      <Autocomplete
        options={statusOptions}
        value={statusOptions.find((opt) => opt.value === status) || null}
        onChange={(_, newValue) => setStatus(newValue?.value || "")}
        getOptionLabel={(option) => option?.label || ""}
        isOptionEqualToValue={(o, v) => o?.value === v?.value}
        renderOption={renderCodeOption}
        renderInput={(params) => (
          <TextField {...params} label="Status" size="small" />
        )}
        style={{ width: 200 }}
      />

      {textFilters.map(([label, value, setter]) => (
        <TextField
          key={label}
          label={label}
          size="small"
          value={value}
          onChange={(e) => setter(e.target.value)}
          style={{ width: 150 }}
        />
      ))}
    </div>
  );
};

export default ApplicantFilters;
